import axios from 'axios';
import { map } from 'ramda';

import * as urls from 'constants/urls';

export const getActionVacancyListHandler = ({ payload }) => axios.get(
    urls.ACTION_VACANCY_LIST.stringify(),
    { params: payload }
);
export const getActionVacancyHandler = ({ payload }) => axios.get(
    urls.ACTION_VACANCY_LIST.stringify({ id: payload })
);

export const postApplicationHandler = ({ payload }) => axios.post(
    urls.APPLICATION_LIST.stringify(),
    payload
);
export const getApplicationListHandler = ({ payload }) => axios.get(
    urls.APPLICATION_LIST.stringify(),
    { params: payload }
);
export const getApplicationHandler = ({ payload }) => axios.get(
    urls.APPLICATION_LIST.stringify({ id: payload })
);

export const getCoursesListHandler = ({ payload }) => axios.get(
    urls.COURSES_LIST.stringify({ userId: payload.user }),
    { params: { work: 1 } }
);

export const getActionListHandler = ({ payload }) => axios.get(
    urls.ACTION_LIST.stringify(),
    { params: payload }
);
export const getActionHandler = ({ payload }) => axios.get(
    urls.ACTION_LIST.stringify({ id: payload })
);

export const getEducationTimesheetHandler = ({ payload }) => axios.get(
    urls.GET_EDUCATION_TIMESHEET.stringify(),
    {
        params: payload
    }
);

export const getApprovalApplicationListHandler = ({ payload }) => axios.get(
    urls.APPROVAL_APPLICATION_LIST.stringify(),
    { params: map(Boolean, payload) }
);
export const getApprovalApplicationListCountersHandler = ({ payload }) => axios.get(
    urls.APPROVAL_APPLICATION_LIST_COUNTERS.stringify(),
    { params: payload }
);
export const getApprovalApplicationHandler = ({ payload }) => axios.get(
    urls.APPROVAL_APPLICATION.stringify(),
    { params: { key: payload } }
);

export const putApprovalApplicationHandler = ({ payload: { ids, title, comment } }) => {
    return axios.all(
        map((id) => axios.put(urls.CREATE_APPROVAL_APPLICATION.stringify(), {
            id: id,
            objStat: {
                stat: title,
                comment: comment
            }
        }), ids)
    );
};

export const getCourseListHandler = ({ payload }) => axios.get(urls.GET_COURSE.stringify(), { params: payload });
export const getCourseHandler = ({ payload }) => axios.get(urls.GET_COURSE.stringify({ id: payload }));

export const getScenarioAuthHandler = ({ payload }) => axios.get(urls.GET_SCENARIO_AUTH.stringify(), { params: payload });
export const getScenarioHandler = ({ payload }) => axios.get(urls.GET_SCENARIO.stringify(), { params: payload });

export const getScenarioTestHandler = ({ payload }) => axios.get(urls.SCENARIO_TEST.stringify(), { params: payload });
export const postScenarioTestHandler = ({ payload }) => axios.post(urls.SCENARIO_TEST.stringify(), payload);

export const getTrainerEventsHandler = ({ payload }) => axios.get(urls.TRAINER_EVENTS.stringify(), { params: payload });
export const putTrainerMarksHandler = ({ payload }) => axios.put(urls.TRAINER_MARKS.stringify({ id: payload.id }), { marks: payload.marks });

export const putEnrollCourseHandler = ({ payload: { peopleId, selected } }) => {
    return axios.all(
        map(({ id, data }) => {
            axios.put(urls.ENROLL_COURSE.stringify(), {
                peopleId,
                libraryObjId: id,
                libraryObjCourseId: data.id
            })
        }, selected)
    );
};

export const getNewsListHandler = ({ payload }) => axios.get(urls.NEWS.stringify(), { params: payload });
export const getNewsHandler = ({ payload }) => axios.get(urls.NEWS.stringify({ id: payload }));

export const getScenarioBookHandler = ({ payload }) => axios.get(urls.SCENARIO_BOOK.stringify({ id: payload }));
export const putScenarioBookReadHandler = ({ payload }) => axios.put(urls.SCENARIO_BOOK.stringify({ id: payload }), {
    state: 'closed'
});

export const getScenarioFileListHandler = ({ payload }) => axios.get(urls.SCENARIO_FILE_LIST.stringify(), {
    params: payload
});
